import React, { SyntheticEvent } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import './App.scss';
import DifferenceIcon from "@mui/icons-material/Difference";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import { useNavigate } from 'react-router';


function App() {
  const title: string = "DIFFING APP";
  const navigate = useNavigate();

  const onRouteClicked = (event: SyntheticEvent, path: string) => {
    event.preventDefault();
    event.stopPropagation();
    navigate(path);
  }

  return (
    <Box sx={{ flexGrow: 1, fontSize: "1rem", marginTop: "8vh" }}>
      <AppBar position="fixed" elevation={3}>
        <Toolbar sx={{ fontFamily: "Signika" }} variant="dense">
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontFamily: "Signika", fontSize: "1rem" }}>
            {title}
          </Typography>
          <Button
            color="inherit"
            variant='text'
            startIcon={<DifferenceIcon />}
            className="nav-button"
            onClick={(e) => onRouteClicked(e, "/")}
          >
            COMPARE
          </Button>
          <Button
            color="inherit"
            variant='text'
            startIcon={<RuleFolderIcon />}
            className="nav-button"
            onClick={(e) => onRouteClicked(e, "/files")}
          >
            FILES
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default App;